import { render, staticRenderFns } from "./gracePassStdDetails.vue?vue&type=template&id=2245cdf2&scoped=true&"
import script from "./gracePassStdDetails.vue?vue&type=script&lang=js&"
export * from "./gracePassStdDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2245cdf2",
  null
  
)

export default component.exports